import { useCallback, useMemo } from 'react';

import { AnalyticalExaminationType } from '@dreryk/drerykweb-medical-dictionaries-api';
import { MostFrequentlyUsedAnalyticalExaminationTypesQuery } from '@dreryk/egabinet-referral-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import {
   AddCircleIcon,
   IconWrapper,
   JustifyContent,
   TableColumnConfiguration,
   ValueRendererProps,
} from '@dreryk/react-components';

import { analyticalExaminationTranslationKeys } from '../../../translations';

export const useMostFrequentlyUsedAnalyticalExaminationTypesQuery = (): UseCqrsQueryResult<
   AnalyticalExaminationType[]
> => {
   return useCqrsSearch(() => new MostFrequentlyUsedAnalyticalExaminationTypesQuery());
};

export const useFrequentAnalyticalExaminationsTableConfiguration = (
   onAddCircleClick: (item: AnalyticalExaminationType) => void
): TableColumnConfiguration<AnalyticalExaminationType>[] => {
   const configuration = useCallback((): TableColumnConfiguration<AnalyticalExaminationType>[] => {
      return [
         {
            label: analyticalExaminationTranslationKeys.analyticalExamination,
            width: '90%',
            accessor: 'name',
            sortingDisabled: true,
         },
         {
            name: 'options',
            label: '',
            width: '10%',
            accessor: 'id',

            renderer: (obj: ValueRendererProps<AnalyticalExaminationType, any>): JSX.Element => {
               return (
                  <IconWrapper testId={'addCircleIcon'} onClick={() => onAddCircleClick(obj.bean)}>
                     <AddCircleIcon />
                  </IconWrapper>
               );
            },
            sortingDisabled: true,
            justifyContent: JustifyContent.END,
         },
      ];
   }, [onAddCircleClick]);

   return useMemo(configuration, [configuration]);
};
